import React, { createContext, useContext, useEffect, useState } from "react";

const Ctx = createContext(null);

export function AppProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("ns_theme") || "light");
  const [contactOpen, setContactOpen] = useState(false);
  const [contactPrefill, setContactPrefill] = useState({});

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem("ns_theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === "light" ? "dark" : "light"));

  const openContact = (prefill = {}) => {
    setContactPrefill(prefill);
    setContactOpen(true);
  };

  return (
    <Ctx.Provider value={{ theme, toggleTheme, contactOpen, setContactOpen, contactPrefill, openContact }}>
      {children}
    </Ctx.Provider>
  );
}

export const useApp = () => useContext(Ctx);
